export default __webpack_public_path__ + "static/media/logo-ct.5dd00aed.png";